module.exports = __webpack_public_path__ + "static/media/korec.9616fc3d.png";